import { _ as _assert_this_initialized } from "@swc/helpers/_/_assert_this_initialized";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import { jsx as _jsx } from "react/jsx-runtime";
import { Animated, Easing, StyleSheet, View } from "react-native";
import GenericTouchable, { TOUCHABLE_STATE } from "./GenericTouchable";
import * as React from "react";
import { Component } from "react";
var TouchableOpacity = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(TouchableOpacity, Component);
    var _super = _create_super(TouchableOpacity);
    function TouchableOpacity() {
        _class_call_check(this, TouchableOpacity);
        var _this;
        _this = _super.apply(this, arguments);
        // opacity is 1 one by default but could be overwritten
        _define_property(_assert_this_initialized(_this), "getChildStyleOpacityWithDefault", function() {
            var childStyle = StyleSheet.flatten(_this.props.style) || {};
            return childStyle.opacity == null ? 1 : childStyle.opacity.valueOf();
        });
        _define_property(_assert_this_initialized(_this), "opacity", new Animated.Value(_this.getChildStyleOpacityWithDefault()));
        _define_property(_assert_this_initialized(_this), "setOpacityTo", function(value, duration) {
            var _this_props_useNativeAnimations;
            Animated.timing(_this.opacity, {
                toValue: value,
                duration: duration,
                easing: Easing.inOut(Easing.quad),
                useNativeDriver: (_this_props_useNativeAnimations = _this.props.useNativeAnimations) !== null && _this_props_useNativeAnimations !== void 0 ? _this_props_useNativeAnimations : true
            }).start();
        });
        _define_property(_assert_this_initialized(_this), "onStateChange", function(_from, to) {
            if (to === TOUCHABLE_STATE.BEGAN) {
                _this.setOpacityTo(_this.props.activeOpacity, 0);
            } else if (to === TOUCHABLE_STATE.UNDETERMINED || to === TOUCHABLE_STATE.MOVED_OUTSIDE) {
                _this.setOpacityTo(_this.getChildStyleOpacityWithDefault(), 150);
            }
        });
        return _this;
    }
    _create_class(TouchableOpacity, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, _this_props_style = _this_props.style, style = _this_props_style === void 0 ? {} : _this_props_style, rest = _object_without_properties(_this_props, [
                    "style"
                ]);
                return /*#__PURE__*/ _jsx(GenericTouchable, _object_spread_props(_object_spread({}, rest), {
                    style: [
                        style,
                        {
                            opacity: this.opacity
                        }
                    ],
                    onStateChange: this.onStateChange,
                    children: this.props.children ? this.props.children : /*#__PURE__*/ _jsx(View, {})
                }));
            }
        }
    ]);
    return TouchableOpacity;
}(Component);
_define_property(TouchableOpacity, "defaultProps", _object_spread_props(_object_spread({}, GenericTouchable.defaultProps), {
    activeOpacity: 0.2
}));
/**
 * TouchableOpacity bases on timing animation which has been used in RN's core
 */ export { TouchableOpacity as default };
